/**
 * Internal dependencies
 */
import FormRegularField from './regular';
import FormPanelField from './panel';
const FORM_FIELD_LAYOUTS = [{
  type: 'regular',
  component: FormRegularField
}, {
  type: 'panel',
  component: FormPanelField
}];
export function getFormFieldLayout(type) {
  return FORM_FIELD_LAYOUTS.find(layout => layout.type === type);
}
//# sourceMappingURL=index.js.map